import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Header() {
  const { t, i18n } = useTranslation();

  const isPT = i18n.language === 'pt-BR';

  return (
    <header>
      <nav className="navbar">
        <div className="navbar-left">
          <Link to="/"><img src="/logo-sem-fundo-branco.png" alt="Celeritas" className="header-logo" /></Link>
          <ul className="navlist">
            <li className="navitem"><Link to="/news">{t('nav.news')}</Link></li>
            <li className="navitem"><Link to="/leagues">{t('nav.leagues')}</Link></li>
            <li className="navitem"><Link to="/championships">{t('nav.championships')}</Link></li>
            <li className="navitem"><Link to="/races">{t('nav.races')}</Link></li>
            <li className="navitem"><Link to="/marketplace">{t('nav.marketplace')}</Link></li>
            <li className="navitem"><Link to="/tools">{t('nav.tools')}</Link></li>
          </ul>
        </div>
        <div className="navbar-right">
          <div className="lang-switcher">
            <button
              className={isPT ? 'lang-btn active' : 'lang-btn'}
              onClick={() => i18n.changeLanguage('pt-BR')}
            >PT</button>
            <span className="lang-divider">|</span>
            <button
              className={!isPT ? 'lang-btn active' : 'lang-btn'}
              onClick={() => i18n.changeLanguage('en')}
            >EN</button>
          </div>
          <a href="https://discord.gg/mR45gCfark" target="_blank" rel="noopener noreferrer" className="navbar-discord">
            <i className="fab fa-discord"></i>
            <span>{t('nav.contact')}</span>
          </a>
          <Link to="/donations" className="navbar-donations">
            <i className="fas fa-heart"></i>
            <span>{t('nav.donations')}</span>
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
